import React from 'react'
import { constants } from 'helpers'

import { Href } from 'components/navigation'
import { Icon, type IconName } from 'components/ui'

const items: { id: string; icon: IconName; link: string }[] = [
  {
    id: 'twitter',
    icon: 'socials/twitter',
    link: constants.socialLinks.twitter,
  },
  {
    id: 'discord',
    icon: 'socials/discord',
    link: constants.socialLinks.discord,
  },
  {
    id: 'telegram',
    icon: 'socials/telegram',
    link: constants.socialLinks.telegram,
  },
  {
    id: 'instagram',
    icon: 'socials/instagram',
    link: constants.socialLinks.instagram,
  },
]

const Social: React.FC = () => {
  return (
    <div className="flex gap-4">
      {items.map((item, index) => (
        <Href
          to={item.link}
          target="_blank"
          key={`${item.link}-${index}`}
          id={`gtm_social_share_${item.id}`}
        >
          <Icon className="size-5" name={item.icon} />
        </Href>
      ))}
    </div>
  )
}

export default Social
